<template>
    <v-dialog v-model="shows" max-width="724" width="100%" content-class="rounded-lg" eager>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-sheet class="fill-height">
            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    포인트 충전하기 - 무통장 입금
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
                <div class="pa-40 pa-lg-60">
                    <account-info v-bind="{ form }" />
                    <v-sheet class="mt-40">
                        <div class="d-flex align-center" style="position: relative">
                            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">입금하실 내용</h5>
                        </div>
                        <vertical-form-table v-model="form" v-bind="{ items }" mode="form">
                            <template #입금액> {{ form?.meta?.amount?.format?.() || 0 }}원 </template>
                            <template #현금영수증>
                                <v-switch v-model="form.meta.cashReceipt.enabled" v-bind="attrs_switch" :label="form.meta.cashReceipt.enabled ? '신청' : '미신청'" class="ml-8" />
                                <v-expand-transition>
                                    <div v-show="form.meta.cashReceipt.enabled">
                                        <v-text-field v-model="form.meta.cashReceipt.content" label="발급받을 전화번호 또는 사업자번호" class="mt-10 mt-lg-16" v-bind="attrs_input" />
                                    </div>
                                </v-expand-transition>
                            </template>
                        </vertical-form-table>

                        <div class="v-btn-group">
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="validate"><span>충전하기</span></v-btn>
                        </div>
                    </v-sheet>
                </div>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch, initBank, initPointForm__account } from "@/assets/variables";

import AccountInfo from "./account-info.vue";
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    { term: "입금액" },
    {
        key: "meta.sender",
        type: "text",
        term: "입금자명",
    },
    { term: "현금영수증" },
].map((item) => ({ ...item, ...attrs_input }));

export default {
    components: {
        AccountInfo,
        BottomSheetHeader,
        VerticalFormTable,
    },
    props: {
        amount: { type: [Number, String], default: 0 },
    },
    data: () => ({
        form: initPointForm__account(),
        items,
        attrs_input,
        attrs_switch,

        shows: false,
        loading: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { amount } = this;
                const { setting } = await api.v1.setting.get();
                this.form = initPointForm__account({
                    meta: {
                        bank: initBank(setting?.shop?.bank),
                        amount,
                    },
                });
            } finally {
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { form } = await api.v1.forms.post(this.form);
                const { bank = {}, amount, sender } = form?.meta || {};

                alert(`요청이 성공적으로 등록되었습니다.\n아래 정보로 입금을 진행해주세요.\n\n은행명: ${bank.name}\n예금주: ${bank.accountHolder}\n계좌번호: ${bank.accountNumber}\n\n입금자명: ${sender}\n입금액: ${amount.format()}원`);
                this.$emit("processed");
            } finally {
                this.loading = false;
            }
        },

        validate() {
            try {
                if (!this.form.meta.sender) throw new Error("임금자명을 입력해주세요");
                if (this.form.meta.cashReceipt.enabled && !this.form.meta.cashReceipt.content) throw new Error("현금영수증을 발급받을 전화번호 또는 사업자번호를 입력해주세요");

                this.save();
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>